import React, { useEffect } from 'react'
import { useAppStore } from '@/stores/appStore'

interface Props {
  children: React.ReactNode
}

export default function AuthLayout({ children }: Props) {
  const organization = useAppStore((state) => state.organization)
  const isLoading = useAppStore((state) => state.isLoading)

  useEffect(() => {
    if (!organization) return
    // set page title
    document.title = organization.name
  }, [organization])

  return (
    <div className='flex min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900'>
      {/* Left Side - Branding */}
      <div className='relative hidden overflow-hidden lg:flex lg:w-1/2 xl:w-3/5'>
        {/* Background Pattern */}
        <div className='absolute inset-0 opacity-10 dark:opacity-20'>
          <div className='absolute left-20 top-20 h-32 w-32 rounded-full bg-white dark:bg-gray-200'></div>
          <div className='absolute right-32 top-40 h-24 w-24 rounded-full bg-white dark:bg-gray-200'></div>
          <div className='absolute bottom-32 left-32 h-40 w-40 rounded-full bg-white dark:bg-gray-200'></div>
          <div className='absolute bottom-20 right-20 h-28 w-28 rounded-full bg-white dark:bg-gray-200'></div>
        </div>

        {/* Content */}
        {!isLoading && (
          <div className='relative z-10 ml-60 flex flex-col justify-center px-16 text-white dark:text-gray-100 xl:px-24'>
            <div className='mb-8'>
              {organization ? (
                <div>
                  <img
                    src={organization.logo ?? ''}
                    alt={organization.name}
                    className='rounded-full'
                    height={64}
                  />
                </div>
              ) : (
                <div className='mb-6 flex items-center'>
                  <h1 className='text-4xl font-bold text-black xl:text-5xl'>
                    Admin Portal
                  </h1>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Right Side - Login Form */}
      <div className='flex h-screen w-full items-center justify-center p-8 lg:w-1/2 lg:p-16 xl:w-2/5'>
        <div className='w-full max-w-lg'>
          <div className='rounded-3xl bg-white p-8 shadow-2xl dark:bg-gray-800 dark:shadow-gray-900/50 lg:px-12 lg:py-32'>
            {!isLoading && (
              <div className='mb-8 text-center'>
                {organization ? (
                  <div className='flex w-full flex-col items-center md:hidden'>
                    <img
                      src={organization.logo ?? ''}
                      alt={organization.name}
                      className='h-[120px] rounded-full'
                    />
                  </div>
                ) : (
                  <h1 className='text-4xl font-bold xl:text-5xl'>
                    Admin Portal
                  </h1>
                )}
              </div>
            )}
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
